import { apiWithAuth } from './api';
export const vdaAPI = apiWithAuth.extend({
    prefixUrl: process.env.VDA_API_URL
});
